import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe, DatePipe } from '@angular/common';

@Pipe({
  name: 'formatting',
  standalone: true,
})
export class FormattingPipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe, private datePipe: DatePipe) { }

  transform(value: any, key?: string): string | null {
    // Never display NaN (number or string) as "NaN"
    if (value !== null && value !== undefined && (typeof value === 'number' ? Number.isNaN(value) : typeof value === 'string' && value.trim().toLowerCase() === 'nan')) {
      return '-';
    }
    // Return value as is if key contains 'id' or 'year'
    if (key) {
      if (
        key.includes('id') ||
        key.includes('Id') ||
        key.includes('ID') ||
        key.includes('year') ||
        key.includes('Year') ||
        key.includes('YEAR') ||
        key.includes('YEARS') ||
        key.includes('years') ||
        key.includes('Years') ||
        key.includes('Period') ||
        key.includes('PERIOD') ||
        key.includes('period') ||
        key.includes('month') ||
        key.includes('Month') ||
        key.includes('MONTH') ||
        key.includes('months') ||
        key.includes('Months') ||
        key.includes('MONTHS') ||
        key.includes('CODE') ||
        key.includes('Code') ||
        key.includes('code')

        // key.includes('Product') ||
        // key.includes('PRODUCT') ||
        // key.includes('product')


      ) {
        return value.toString();
      }
    }

    if (
      typeof value === 'string' &&
      /^\d{4}$/.test(value) &&
      +value >= 1970 &&
      +value <= 2030
    ) {
     
      return value;
    }
    // Check if the value is a valid number and format it with commas, keeping two decimal digits
    if (!isNaN(+value) && isFinite(value)) {
      return this.decimalPipe.transform(+value, '1.2-2'); // Ensure 2 decimal places
    }

    // Check if the value is a string that represents a date and format it to 'DD/MM/YYYY'
    if (typeof value === 'string' && this.isStrictlyValidDate(value)) {
      return this.datePipe.transform(new Date(value), 'dd/MM/yyyy');
    }

    // If none of the above, return the value as it is - but never show "NaN"
    const str = value != null ? String(value).trim().toLowerCase() : '';
    if (str === 'nan' || (typeof value === 'number' && Number.isNaN(value))) return '-';
    return value;
  }

  private isStrictlyValidDate(value: string): boolean {
    // Regex to match date formats like YYYY-MM-DD or YYYY-MM-DDTHH:mm:ss.sssZ
    const isoDateFormat = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3})?Z?)?$/;
    if (!isoDateFormat.test(value)) {
      return false;
    }

    // Check if the date string is valid
    const date = new Date(value);
    return !isNaN(date.getTime());
  }
}
